"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _isBrowser = _interopRequireDefault(require("./is-browser"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/*
 * A custom hook which listens for a specific keypress; the state is set on keydown
 * and cleared on keyup, so that consumers receive notification of a 'keydown' in
 * a single render cycle only.
 *
 * An onKeyUp callback function can also be passed in to register a function with the key-up event of the key press.
 *
 * NOTE: uses `KeyboardEvent.key`, as this has strong cross browser support.
 * https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent
 */
var _default = exports["default"] = function _default(_ref) {
  var targetKeyValue = _ref.targetKeyValue,
    _ref$onKeyUp = _ref.onKeyUp,
    onKeyUp = _ref$onKeyUp === void 0 ? function () {} : _ref$onKeyUp;
  if (!_isBrowser["default"]) {
    return;
  }
  // to lower case so things like "Escape" vs "escape" match
  var targetKey = targetKeyValue === null || targetKeyValue === void 0 ? void 0 : targetKeyValue.toLowerCase();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    keyPressed = _useState2[0],
    setKeyPressed = _useState2[1];
  var keyDownHandler = function keyDownHandler(_ref2) {
    var key = _ref2.key;
    if ((key === null || key === void 0 ? void 0 : key.toLowerCase()) === targetKey) {
      setKeyPressed(true);
    }
  };
  var keyUpHandler = function keyUpHandler(_ref3) {
    var key = _ref3.key;
    if ((key === null || key === void 0 ? void 0 : key.toLowerCase()) === targetKey) {
      setKeyPressed(false);
      onKeyUp();
    }
  };
  (0, _react.useEffect)(function () {
    window.addEventListener('keydown', keyDownHandler);
    window.addEventListener('keyup', keyUpHandler);
    return function () {
      window.removeEventListener('keydown', keyDownHandler);
      window.removeEventListener('keyup', keyUpHandler);
    };
  }, []);
  return keyPressed;
};